module.exports = {
  "CS_FE_Select_Product_VbhT": "Выберите «Роль менеджера по продукту и разработчика».",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Sorry_permissions_nBRG": "К сожалению, у вас нет права доступа к системе. Чтобы запросить такое право, следуйте инструкциям ниже.",
  "CS_system_Submission_cEep": "Отправить",
  "CS_Workbench_Online_Customer_yXxN": "Панель онлайн-чата",
  "CS_1_WiFi_pyYD": "Wi-Fi",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Production_and_mGLI": "Выберите тип необходимого права доступа ниже, затем нажмите «Применить».\n\nДля членов команды разработки и обслуживания продуктов справочного центра: выберите «PM and DEV Role»\n\nДля других ролей (разработка и обслуживание продуктов IBT, операционный или местный обслуживающий персонал): выберите «CRM View Permission (Role ID: 14211591)»",
  "CS_FE_You_can_yIrn": "Выберите необходимый тип прав доступа ниже, затем нажмите «Подать заявку».",
  "CS_1_Country_ilYw": "Страна",
  "CS_1_Closed_automatic_jUvk": "Отключить автоматическое назначение обращений",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_See_permissions_OzjQ": "Подробную информацию см. в Руководстве по доступу к системе справочного центра",
  "CS_1_System_Category_rAJC": "Категория бизнеса",
  "CS_1_Environment_Bitb": "Среда",
  "CS_1_View_Current_IOCz": "Посмотреть существующие права доступа",
  "CS_FE_If_you_lCHy": "Если вы входите в команду разработки и обслуживания продуктов службы поддержки:",
  "CS_1_Upgrade_current_dlbi": "Расширить существующие права доступа",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_vLUC": "Для специалистов справочного центра:",
  "CS_feedback_Please_upload_zHqW": "2. Загрузите полное изображение страницы, чтобы мы смогли лучше понять проблему.",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_oPui": "Для специалистов справочного центра:",
  "CS_feedback_Feedback_bGXI": "Отзыв",
  "CS_Status_In_the_PrHj": "На вынужденном перерыве",
  "CS_1_Personal_settings_eXQD": "Личные настройки",
  "CS_FE_Product_R_RxVt": "Роль менеджера по продукту и разработчика",
  "CS_1_Thank_you_WUlL": "Спасибо за отзыв!",
  "CS_1_Online_Customer_SvgB": "Онлайн-чат включен",
  "CS_1_Log_in_sMmF": "Выйти",
  "CS_1_Open_Online_umkV": "Включить онлайн-чат",
  "CS_1_Languages_hMbf": "Язык",
  "CS_feedback_1_Please_IBbL": "1. Опишите функцию, с которой у вас возникли проблемы, и что произошло.",
  "CS_1_Personal_settings_uOXW": "Личные настройки",
  "CS_FE_Choose_Ark_VJpl": "Выберите «Право просмотра CRM (идентификатор роли: 14211591)».",
  "CS_1_Closing_Online_tykf": "Отключить онлайн-чат",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Permission_Kapv": "Выберите право доступа",
  "CS_1_Permissions_MuvF": "Права доступа",
  "CS_FE_If_you_WAuP": "Если у вас другая роль (например, разработка и обслуживание продуктов IBT, операционный персонал или сотрудник, находящийся в Китае):",
  "CS_1_Automatic_Order_Mnnv": "Автоматическое назначение обращений включено",
  "CS_1_Open_automatic_PZyZ": "Включить автоматическое назначение обращений",
  "CS_FE_Ark_Visitor_pMCT": "Право просмотра CRM",
  "CS_1_Enter_text_NYGo": "Введите текст...",
  "CS_1_Comments_RcMN": "Отправить",
  "CS_1_Notification_uJTM": "Уведомления",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Hello_permissions_SDxI": "Обратитесь за помощью к своему руководителю или локальному администратору, ответственному за права доступа справочного центра.",
  "statusChange": "Чтобы автоматически принимать обращения, установите рабочий статус «Доступен».",
  "CS_Workbench_There_are_wmir": "Невозможно изменить рабочий статус. Сначала завершите все открытые онлайн-чаты.",
  "status_400": "Идет перерыв на обед…",
  "refreshPage": "Обновить страницу",
  "type": "Тип сообщения",
  "status_200": "Идет обучение…",
  "cancel": "отмена",
  "countDownBegin": "Работа после ",
  "infoChange": "На другой странице выполнено переключение категории системы. Система не сможет сохранить внесенные изменения. Обновите страницу.",
  "logout": "выйти",
  "sendTo": "получатель",
  "view": "Посмотреть",
  "satisfaction_content": "Вам доступен опрос, его заполнение займет не более 5 минут. Если вы хотите заполнить его сейчас, нажмите на ссылку ниже или на кнопку «Продолжить», чтобы перейти на страницу опроса.",
  "online": "Сетевая среда",
  "message": "Сообщения",
  "CS_Workbench_Open_the_lnHa": "При использовании панели онлайн-чата рабочий статус должен быть «Доступен».",
  "ticketNumber": "",
  "more": "Подробнее",
  "satisfaction_title": "A survey for you",
  "changeStatusV1": "Ваш текущий статус — «",
  "changeStatusV2": "». Действительно изменить статус на «",
  "pre": "Среда до события",
  "changeStatusV3": "»?",
  "time": "Время",
  "continue": "Продолжить",
  "knowledge": "База данных",
  "customerService": "Колл-центр",
  "status_300": "Идет встреча…",
  "sendFrom": "отправитель",
  "status_500": "Идет перерыв…",
  "artificial": "Прямое сообщение",
  "countDownEnd": "S",
  "youhave": "Обращений, ожидающих рассмотрения: ",
  "startWorking": "Начать работу",
  "small": "Среда принятия заявки",
  "offWorkV": "Действительно выйти из сети? Ваш рабочий день будет завершен.",
  "read": "Прочитано",
  "clickStartWorking": "Чтобы обеспечить правильность данных, перед использованием системы нажмите кнопку «Начать работу»",
  "Settings": "Настройки",
  "welcomeCS": "Добро пожаловать в глобальную систему справочного центра DiDi!",
  "cs-micro-front-end---more": "",
  "cs-micro-front-end---welcomeCS": "",
  "cs-micro-front-end---clickStartWorking": "",
  "cs-micro-front-end---startWorking": "",
  "cs-micro-front-end---status_200": "",
  "cs-micro-front-end---status_300": "",
  "cs-micro-front-end---status_400": "",
  "cs-micro-front-end---status_500": "",
  "cs-micro-front-end---offWorkV": "",
  "cs-micro-front-end---changeStatusV1": "",
  "cs-micro-front-end---changeStatusV2": "",
  "cs-micro-front-end---changeStatusV3": "",
  "cs-micro-front-end---cancel": "",
  "cs-micro-front-end---continue": "",
  "cs-micro-front-end---logout": "",
  "cs-micro-front-end---online": "",
  "cs-micro-front-end---pre": "",
  "cs-micro-front-end---small": "",
  "cs-micro-front-end---statusChange": "",
  "cs-micro-front-end---youhave": "",
  "cs-micro-front-end---ticketNumber": "",
  "cs-micro-front-end---view": "",
  "cs-micro-front-end---Settings": "",
  "cs-micro-front-end---infoChange": "",
  "cs-micro-front-end---refreshPage": "",
  "cs-micro-front-end---satisfaction_title": "",
  "cs-micro-front-end---satisfaction_content": "",
  "cs-micro-front-end---knowledge": "",
  "cs-micro-front-end---customerService": "",
  "cs-micro-front-end---artificial": "",
  "cs-micro-front-end---sendFrom": "",
  "cs-micro-front-end---sendTo": "",
  "cs-micro-front-end---type": "",
  "cs-micro-front-end---time": "",
  "cs-micro-front-end---read": "",
  "cs-micro-front-end---countDownBegin": "",
  "cs-micro-front-end---countDownEnd": "",
  "cs-micro-front-end---CS_Workbench_There_are_wmir": "",
  "cs-micro-front-end---CS_Workbench_Open_the_lnHa": "",
  "cs-micro-front-end---message": "",
  "CS_system_Name_of_QEFT": "Position Name",
  "CS_system_Sectoral_information_JizK": "Department Info",
  "CS_system_Immediate_superior_VDep": "Supervisor",
  "CS_optimazation_Make_sure_FVAQ": "Are you sure you want to switch the status of {{workbench_name}} from {{status_one}} to {{status_two}}? Once switched, the status of other workbenches will be set to {{status_three}}.",
  "CS_optimazation_The_status_hqOj": "Unable to switch status. Please log in to Genesys.",
  "CS_optimazation_You_have_PlRk": "You have been idle in {{workbench_name}} for {{time_duration}} minute(s). Do you want to continue working in {{workbench_name}}?",
  "CS_optimazation__work_JhhB": "You have been {{work_status}} for more than {{time_duration}} minutes. Do you want to remain {{work_status}}?",
  "CS_optimazation_Time_out_sqTe": "Timeout Reminder",
  "CS_optimazation_After_the_dZsk": "Post-call Processing",
  "CS_optimazation_Telephone_workstations_TBZP": "Call Workbench",
  "CS_optimazation_Asynchronous_workstations_JwBF": "Written Workbench",
  "CS_optimazation__akmu": "Offline",
  "CS_optimazation__ZkZb": "Stay {{work_status}}",
  "CS_optimazation__CALn": "Your status was automatically changed to offline due to inactivity. Please refresh the page.",
  "CS_optimazation__zXnN": "{{work_status}} Timeout",
  "CS_System_lIGK_Ukwr": "Current skill type",
  "CS_System_ZQjn_eCbz": "Previously trained skill type",
  "CS_status_zoxI_Nral": "The current service type is {{service_type}}",
  "CS_status_aobY_gRor": "You have been {{status_name}} for more than {{hour_time}} hour(s). Do you want to stay {{status_name}}?",
  "CS_status_Dibi_hJVY": "Continue ({{time_second}})",
  "CS_status_YyJG_Khkr": "Frontline customer service",
  "CS_status_ocdu_QQQW": "Video call",
  "CS_status_wfIq_oGhU": "Social media",
  "CS_status_ErSl_RYFT": "Call",
  "CS_status_CjDQ_uaVo": "Anti-fraud",
  "CS_status_WEAx_MWhv": "Safety",
  "CS_status_SYOk_iYUs": "B2B",
  "CS_status_ZoGi_sjyC": "Driver Center",
  "CS_status_dweh_wRWT": "Onboarding review",
  "CS_status_qORz_iUKj": "Collections",
  "CS_status_ixVR_bjQc": "Sales",
  "CS_status_HMDn_eBqC": "Engagement",
  "CS_status_HxNd_EpND": "Dashcam",
  "CS_status_eJtD_Xawt": "Tech support",
  "CS_status_pySZ_YnQN": "Content review"
}